// Footer component
const Footer = () => {
    return (
        <footer>
            <div className="wrapper">
                <p>Created at Juno College &copy;</p>
            </div>
        </footer>
    );
};

export default Footer;